var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaybillTimely(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 214,
    height: 54,
    viewBox: "0 0 214 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2086",
    x: 14.86,
    y: 4.998,
    width: 40.337,
    height: 32.005,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2088",
    x: 14.803,
    y: 12.998,
    width: 38.457,
    height: 32.004,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2087",
    x: 14.746,
    y: 8.999,
    width: 36.578,
    height: 32.003,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", null), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7114",
    "data-name": "Group 7114",
    transform: "translate(-125 -1190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2030",
    "data-name": "Rectangle 2030",
    transform: "translate(125 1190)",
    fill: "#a852de",
    stroke: "#9649c7",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 214,
    height: 54,
    rx: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 213,
    height: 53,
    rx: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Pay_bills_timely",
    "data-name": "Pay bills timely",
    transform: "translate(191 1225)",
    fill: "#212121",
    fontSize: 20,
    fontFamily: "JioType-Medium, JioType",
    fontWeight: 500,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pay bills timely")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(141 1196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2084",
    "data-name": "Rectangle 2084",
    d: "M1.924.009,15.312.07a1.826,1.826,0,0,1,.74.16,1.914,1.914,0,0,1,.6.43,2.017,2.017,0,0,1,.407.635,2.076,2.076,0,0,1,.149.777V22.007a2.076,2.076,0,0,1-.149.777,2.017,2.017,0,0,1-.407.635,1.914,1.914,0,0,1-.6.43,1.826,1.826,0,0,1-.74.16L1.924,24.07a1.844,1.844,0,0,1-.749-.154,1.913,1.913,0,0,1-.612-.427,2,2,0,0,1-.412-.636A2.069,2.069,0,0,1,0,22.073V2.007a2.069,2.069,0,0,1,.151-.78A2,2,0,0,1,.564.59,1.913,1.913,0,0,1,1.175.163,1.844,1.844,0,0,1,1.924.009Z",
    transform: "translate(152.364 1204.96)",
    fill: "#a44fd8",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2085",
    "data-name": "Rectangle 2085",
    d: "M1.924.009,15.312.07a1.826,1.826,0,0,1,.74.16,1.914,1.914,0,0,1,.6.43,2.017,2.017,0,0,1,.407.635,2.076,2.076,0,0,1,.149.777V22.007a2.076,2.076,0,0,1-.149.777,2.017,2.017,0,0,1-.407.635,1.914,1.914,0,0,1-.6.43,1.826,1.826,0,0,1-.74.16L1.924,24.07a1.844,1.844,0,0,1-.749-.154,1.913,1.913,0,0,1-.612-.427,2,2,0,0,1-.412-.636A2.069,2.069,0,0,1,0,22.073V2.007a2.069,2.069,0,0,1,.151-.78A2,2,0,0,1,.564.59,1.913,1.913,0,0,1,1.175.163,1.844,1.844,0,0,1,1.924.009Z",
    transform: "translate(154.364 1205.96)",
    fill: "#aa53e0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125, 1190)",
    filter: "url(#Rectangle_2086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2086-2",
    "data-name": "Rectangle 2086",
    d: "M18.944,15,27.4,15a.883.883,0,0,1,.364.079.937.937,0,0,1,.3.214,1.006,1.006,0,0,1,.2.317,1.063,1.063,0,0,1,0,.777,1.006,1.006,0,0,1-.2.317.937.937,0,0,1-.3.214A.883.883,0,0,1,27.4,17l-8.457,0a.893.893,0,0,1-.367-.079.944.944,0,0,1-.3-.215,1.009,1.009,0,0,1-.2-.319,1.063,1.063,0,0,1,0-.78,1.009,1.009,0,0,1,.2-.319.944.944,0,0,1,.3-.215A.893.893,0,0,1,18.944,15Z",
    transform: "translate(14.86 5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125, 1190)",
    filter: "url(#Rectangle_2088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2088-2",
    "data-name": "Rectangle 2088",
    d: "M18.943,15l6.578,0a.885.885,0,0,1,.365.079.938.938,0,0,1,.3.214,1.006,1.006,0,0,1,.2.317,1.063,1.063,0,0,1,0,.777,1.006,1.006,0,0,1-.2.317.938.938,0,0,1-.3.214.884.884,0,0,1-.365.079l-6.578,0a.892.892,0,0,1-.367-.079.943.943,0,0,1-.3-.215,1.009,1.009,0,0,1-.2-.318,1.063,1.063,0,0,1,0-.78,1.009,1.009,0,0,1,.2-.318.943.943,0,0,1,.3-.215A.892.892,0,0,1,18.943,15Z",
    transform: "translate(14.8 13)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125, 1190)",
    filter: "url(#Rectangle_2087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2087-2",
    "data-name": "Rectangle 2087",
    d: "M18.942,15l4.7,0a.886.886,0,0,1,.365.079.938.938,0,0,1,.3.214,1.007,1.007,0,0,1,.2.317,1.063,1.063,0,0,1,0,.777,1.006,1.006,0,0,1-.2.317.938.938,0,0,1-.3.214.886.886,0,0,1-.365.079l-4.7,0a.891.891,0,0,1-.367-.079.942.942,0,0,1-.3-.214,1.008,1.008,0,0,1-.2-.318,1.063,1.063,0,0,1,0-.78,1.008,1.008,0,0,1,.2-.318.942.942,0,0,1,.3-.214A.891.891,0,0,1,18.942,15Z",
    transform: "translate(14.75 9)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaybillTimely);
export default __webpack_public_path__ + "static/media/paybill-timely.2d7572c033be48a0d985f0aa432d5588.svg";
export { ForwardRef as ReactComponent };